// import('bootstrap');
// window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');
// require('bootstrap/dist/js/bootstrap.bundle.js');
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
require('popper.js');